import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { InvoicesScreen } from "../screens/InvoicesScreen";
import { invoicesSearch } from "../screens/salesSearch";

export const Route = createFileRoute("/prototype/c/$companyId/sales/invoices/")({
  validateSearch: (search) => invoicesSearch.parse(search),
  component: SalesInvoices,
});

function SalesInvoices() {
  const { companyId } = Route.useParams();
  const { tab, due } = Route.useSearch();
  return (
    <InvoicesScreen
      companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY}
      tab={tab}
      due={due}
    />
  );
}
